import React, { useEffect, useContext, useState } from 'react'
import { Prompt, useParams, useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'

import { UIContext } from '../../context/ui-state'
import { DashboardContext } from '../../context/dashboard-state'

import { formatCurrency } from '../../config/adapters'
import { PREVENT_NAVIGATION_MESSAGE } from '../../config/constants'
import { CURRENCY_REGEX, NOT_EMPTY_REGEX } from '../../config/validators'

import PledgeOrderDetails from '../../modules/pledge-order-details/pledge-order-details'
import PledgeOrderContents from '../../modules/pledge-order-contents/pledge-order-contents'

import CustomField from '../../components/custom-field/custom-field'

import './pledge-credit-transfer.scss'

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

const PledgeCreditTransfer = props => {

  const UI = useContext( UIContext )
  const dashboardContext = useContext( DashboardContext )
  const { pledge, transferPledgeCredit } = dashboardContext
  const { details } = pledge
  const [ hasChanges, setHasChanges ] = useState( false )
  const { className = '' } = props
  const { pledgeId } = useParams()
  const history = useHistory()

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  const initialize = () => { }

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  const handleValidation = values => {
    let errors = {}

    if ( !CURRENCY_REGEX.test( values.amount ) ) errors.amount = 'Invalid amount'
    if ( !NOT_EMPTY_REGEX.test( values.reason ) ) errors.reason = 'Invalid reason'

    return errors
  }

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  const handleSave = async ( payload, actions ) => {
    if ( !window.confirm( `Are you sure you want to transfer ${ formatCurrency( payload.amount ) }?\n\nThis action can't be undone.` ) ) return

    actions.setSubmitting( true )

    try {

      await transferPledgeCredit( pledgeId, payload )

      setHasChanges( false )
      UI.showSuccessDisclaimer( 'The credit transfer was applied successfully!' )
      history.push( `/dashboard/pledge/${ pledgeId }/transaction-history` )

    } catch ( exception ) { UI.showErrorDisclaimer( exception.message ) }

    actions.setSubmitting( false )
  }

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect( initialize, [] )

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  return (

    <section className={ `pd-pledge-credit-transfer ${ className }` }>
      <Prompt when={ hasChanges } message={ location => PREVENT_NAVIGATION_MESSAGE } />

      <PledgeOrderDetails details={ details } className="pd-pledge-credit-transfer__order" />

      <Formik
        initialValues={ { amount: '', reason: '' } }
        onSubmit={ handleSave }
        validate={ handleValidation }
        validateOnChange={ false }
        validateOnBlur={ false }>
        { fProps => (

          <Form className={ `pd-pledge-credit-transfer__main pd-white-box` } onChange={ event => setHasChanges( true ) }>
            <CustomField label="Amount" name="amount" required />
            <CustomField label="Reason" name="reason" maxLength={ 250 } required />

            <button
              className="pd-button pd-button--navy"
              type="submit"
              disabled={ fProps.isSubmitting }>
              { fProps.isSubmitting ? 'Processing...' : 'Transfer credit' }
            </button>
          </Form>

        ) }
      </Formik>


      <PledgeOrderContents details={ details } className="pd-pledge-credit-transfer__contents" />
    </section>

  )

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
}

export default PledgeCreditTransfer